/** A turn belongs to its conversation, independently of which conversation is being viewed. */
export class ConversationRuns {
    records = new Map();
    get(id) { return this.records.get(id); }
    values() { return [...this.records.values()]; }
    begin(id, value) {
        this.stop(id);
        const run = { id, value, state: 'running', cancel: null };
        this.records.set(id, run);
        return run;
    }
    remember(id, value) {
        const existing = this.get(id);
        if (existing)
            existing.value = value;
        else
            this.records.set(id, { id, value, state: 'complete', cancel: null });
    }
    active(run) { return this.get(run.id) === run && run.state === 'running'; }
    finish(run) {
        if (this.active(run)) {
            run.state = 'complete';
            run.cancel = null;
        }
    }
    stop(id) {
        const run = this.get(id);
        if (!run || run.state !== 'running')
            return;
        run.state = 'stopped';
        const cancel = run.cancel;
        run.cancel = null;
        cancel?.();
    }
    remove(id) { this.stop(id); this.records.delete(id); }
    clear() { for (const id of this.records.keys())
        this.stop(id); this.records.clear(); }
}
//# sourceMappingURL=conversationRuns.js.map